export default __webpack_public_path__ + "42b7e081821c1b506c78758cdf776cf4.png";